import { Injectable } from '@angular/core'
import { findIndex } from 'lodash'
import { BehaviorSubject, Observable } from 'rxjs'
import { SortParams } from '../../../shared/utilities/http-params'

export type SortEvent = Readonly<{
  name: string;
  multi: boolean;
}>

export type CurrentSort = SortParams & Readonly<{ order?: number }>


@Injectable({
  providedIn: 'any',
})
export class TableSortService {
  private sortOrder$ = new BehaviorSubject<readonly SortParams[]>([])

  next({ name, multi }: SortEvent) {
    const currentValue = this.sortOrder$.getValue()
    const currentSort = currentValue.find(_ => _.name === name)
    const newColumnSort: SortParams = {
      name,
      ...!currentSort || currentSort.direction === 'desc' ? {} : { direction: 'desc' },
    }

    const getNewValue = () => {
      if (multi) {
        // if already sorted by the column just flip the asc/desc in place. otherwise add to the end
        return currentSort
          ? currentValue.map(o => o.name === name ? newColumnSort : o)
          : [...currentValue, newColumnSort]
      } else {
        return [newColumnSort]
      }
    }

    const newValue = getNewValue()
    this.setSortOrder(newValue)
  }

  setSortOrder(sortOrder: readonly SortParams[]) {
    this.sortOrder$.next(sortOrder)
  }

  getSortOrder(): readonly SortParams[] {
    return this.sortOrder$.getValue()
  }

  getOrder(): Observable<readonly SortParams[]> {
    return this.sortOrder$
  }

  getCurrentSort(name: string): CurrentSort | undefined {
    const sortOrder = this.getSortOrder()
    const current = sortOrder.find(_ => _.name === name)
    if (current) {
      return {
        ...current,
        ...sortOrder.length === 1 ? {} : { order: 1 + findIndex(sortOrder, _ => _.name === name) },
      }
    } else {
      return undefined
    }
  }
}
